import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Chicago Portal": {
    parameters: {
      linkUrls: ["https://operations.chicagopolice.org/FIMSPublic/"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
      includeLepcs: [
        {
          id: "591",
          name: "Chicago LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "IL",
  },
  "Illinois State Portal": {
    parameters: {
      linkUrls: ["https://tierii.iema.state.il.us/TIER2MANAGER/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "IL",
  },
};
